import { render } from "./Passengers.vue?vue&type=template&id=7cadba90&scoped=true"
import script from "./Passengers.vue?vue&type=script&lang=js"
export * from "./Passengers.vue?vue&type=script&lang=js"

import "./Passengers.vue?vue&type=style&index=0&id=7cadba90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cadba90"]])

export default __exports__